import { DataContainerService } from "../../../../../infrastructure/datacontainer.service";
import { TransportData } from "../../../../../infrastructure/transportdata";

export interface DrillDownReportColumn {
  field: string;
  caption: string;
  data_type: number;
  child_column?: DrillDownReportColumn[];
}

export interface DrillDownCardCount {
  filter_by: number;   // age group or hospital type
  count: number;
}

export type DrillDownRow = Record<string, string | number | null>;
export type DrillDownGrandTotals = Record<string, number>;

export class DashboardDrilldownReport {
  public static readonly EmbedCollectionName: string = "drilldown";

  Rows: DrillDownRow[] = [];
  Columns: DrillDownReportColumn[] = [];
  Cards: DrillDownCardCount[] = [];
  TotalRowsCount: number = 0;
  GrandTotals: DrillDownGrandTotals | null = null;
  SearchTextPlaceholder: string = "";
  IsNewRecordAvailable: number = 0;

  public static FromTransportData(td: TransportData) {
    let result: DashboardDrilldownReport = null as any;
    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(td.MainData, DashboardDrilldownReport.EmbedCollectionName)) {
      let coll = dcs.GetCollection(td.MainData, DashboardDrilldownReport.EmbedCollectionName)!;
      for (let data of coll.Entries) {
        result = data as DashboardDrilldownReport;
      }
    } else {
      result = new DashboardDrilldownReport();
    }
    return result;
  }
}